<template>
  <div>
    <div class="mg_t" :style="`background: url(${imageUrlList[1]}) repeat scroll 0% 0% / 100% 100%;`">
      <div class="mg_t_top">
        <div class="logo">
          <img src="../../assets/2021031116021152193.png" />
        </div>
        <div class="search">
          <form>
            <table
              border="0"
              cellpadding="0"
              cellspacing="0"
              width="230"
              style="background: #f1f1f1"
            >
              <tbody>
                <tr>
                    <!-- <td valign="center" class="uy">
                        <p class="uk" id="ng">标题</p>
                        <ul class="up">
                            <li class="uk" id="nh">标题</li>
                            <li class="uk" id="nj">短标题</li>
                        </ul>
                    </td> -->
                  <td valign="center">
                    <input
                      class="search-input lk"
                      v-model="keyword"
                      placeholder="请输入关键词！"
                      type="text"
                    />
                  </td>
                  <td align="center" valign="top" width="50">
                    <img
                      @click="goSearch()"
                      src="../../assets/2018090712332983862.jpg"
                      style="cursor: pointer"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </form>
        </div>
        <div class="caidanl">
          <ul>
            <!-- v-if="lang == 't'" -->
            <li>
              <a @click="changeLang('s');" href="javascript:;">中文</a>
            </li>
            <li>
              <a href="https://www.magang.com.cn/en" target="_blank">English</a>
            </li>
            <!-- v-if="lang == 's'" -->
            <li>
              <a
                href="javascript:;"
                title="点击以简体中文方式浏览"
                @click="changeLang('t');"
                >繁体</a
              >
            </li>
            <li class="vxx">
              <a href="#" target="_blank"
                ><img src="../../assets/2018082415221883863.png"
              /></a>
              <div class="vx">
                <img src="../../assets/2018090716441774898.png" />
              </div>
            </li>
            <li class="sjj">
              <a href="#" target="_blank"
                ><img src="../../assets/2018082415222873530.png"
              /></a>
              <div class="sj">
                <!--<img src="../../assets/2018090801010811928.png">-->
              </div>
            </li>
          </ul>
        </div>
        <div class="clear"></div>
      </div>
      <div class="dhl">
        <ul>
          <li>
            <a
              href="/"
              target="_blank"
              :class="path == '/' ? 'dhl_hover' : 'dhl_out'"
              >网站首页</a
            >
          </li>
          <li
            v-for="(item, index) in datas"
            v-if="item.isShow != 0"
            :key="index"
            class="qwe"
          >
            <a
              @click="
                childLinkUrl(
                  item,
                  item.nodeName == '联系我们' ? item : item.childs[0]
                )
              "
              href="javascript:;"
              :class="nodeId == item.nodeId ? 'dhl_hover' : 'dhl_out'"
              >{{ item.nodeName }}</a
            >
            <div class="dhxl">
              <table
                border="0"
                style="border-collapse: collapse; background: #f0f3f8"
              >
                <tbody>
                  <tr>
                    <td v-for="(citem, cindex) in item.childs" :key="cindex">
                      <a
                        @click="childLinkUrl(item, citem)"
                        href="javascript:;"
                        >{{ citem.nodeName }}</a
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </li>
          <div class="clear"></div>
        </ul>
      </div>
    </div>
    <div v-if="isVisible && path == '/'" class="banner column" id="bn1" name="banner" runat="server">
      <div
        class="portlet"
        id="45a85d1079be4425a753d235df4bb489"
        pagemoduleid="da7dbea58e2e430ea49ff36d37437310"
      >
        <div align="left" class="portlet-header" style="display: none">
          <span id="menu"> </span>
          <div id="submenu45a85d1079be4425a753d235df4bb489" class="shadow dn">
            <ul class="float_list_ul"></ul>
          </div>
        </div>
        <div>
          <img
            id="imgs"
            :src="imageUrlList[0]"
            style="width: 100%"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  API_GetMenuList,
  API_GetNewsListddh
} from "@/fetch/api"
export default {
  data () {
    return {
      isActive: '',
      datas: [],
      keyword: '',
      path: '',
      nodeId: '',
      imageUrlList: [],
      isVisible:true,
      lang:'',
    }
  },
  beforeMount () {
    API_GetMenuList()
      .then(res => {
        let data = {
          firstLevelMenuList: [],
          firstLevelMenuListById: {},
          secondLevelMenuListById: {},
          menuList: []
        }
        let dataObj = res.data[0].childs
        this.datas = dataObj
        data.menuList = dataObj
        this.$store.commit("dataObj", data)
      })
      .catch(error => {
        console.log(error)
      })

  },
  watch: {
    $route () {
      if (this.$route.params.nodeId) {
        this.nodeId = this.$route.params.nodeId
      }
      this.path = this.$route.path
    }
  },
  created () {
    this.getNewsList(4025)
  },

  mounted () {
    if(window.getCookie('zh_choose')){
        this.lang = window.getCookie('zh_choose')
    }
  },
  methods: {
    changeLang(l){
        this.lang = l
        window.zh_tran(l) 
    },
    getNewsList (nodeId) {
      API_GetNewsListddh({
        pageNo: 0,
        pageSize: 5,
        nodeId: nodeId,
      })
        .then(res => {
          let { data } = res.data
          this.imageUrlList = data[0].imageUrlList
          setTimeout(() => {
                this.isVisible = false; // 延迟后隐藏 `div`
            }, 3000);
        })
        .catch(err => {
          console.log(err)
        })
    },
    goSearch () {
      if (this.keyword != '') {
        this.$router.push(`/search?keyword=${this.keyword}`)
      }
    },
    linkUrl (item) {
      let cnodeId = item.childs ? item.childs[0].nodeId : ''
      let params = { nodeId: item.nodeId, cnodeId: cnodeId }
      switch (item.nodeName) {
        case "公司概况":
          this.$router.push({ name: 'aboutUs', params: params })
          break
        case "联系我们":
          this.$router.push({ name: 'technology', params: params })
          break
        case "行业案例":
          this.$router.push({ name: 'case', params: params })
          break
        case "服务支持":
          this.$router.push({ name: 'service', params: params })
          break
        case "新闻中心":
          this.$router.push({ name: 'newsList', params: params })
          break
        case "关于我们":
          this.$router.push({ name: 'aboutUs', params: params })
          break
      }
    },

    childLinkUrl (item, citem) {
      switch (item.nodeName) {
        case "公司概况":
          this.$router.push({ name: 'aboutUs', params: { nodeId: item.nodeId, cnodeId: citem.nodeId } })
          break
        case "联系我们":
          this.$router.push({ name: 'aboutUs', params: { nodeId: item.nodeId, cnodeId: citem.nodeId } })
          break
        case "新闻资讯":
          this.$router.push({ name: 'newsList', params: { nodeId: item.nodeId, cnodeId: citem.nodeId } })
          break
        case "产业展示":
          this.$router.push({ name: 'industry', params: { nodeId: item.nodeId, cnodeId: citem.nodeId } })
          break
        case "企业文化":
          this.$router.push({ name: 'corporateCulture', params: { nodeId: item.nodeId} })
          break
        case "投资者关系":
          this.$router.push({ name: 'investor', params: { nodeId: item.nodeId, cnodeId: citem.nodeId } })
          break
        case "社会责任":
          this.$router.push({ name: 'newsList', params: { nodeId: item.nodeId, cnodeId: citem.nodeId } })
          break
      }
    },
  }
}
</script>
<style scoped>
.uy {
  width: 55px;
  border-right: 1px solid #e4d6d6;
}

#ng {
  background: url(../../assets/2019060700541660624.png) no-repeat right;
}

.lk {
  margin: 0px;
  border: none;
  padding-left: 10px;
  color: #a89da8;
  background: #f1f1f1;
  width: 180px;
  height: 30px;
  font-size: 12px;
  line-height: 30px;
  font-family: "微软雅黑";
}

.uk {
  margin: 0px;
  border: none;
  text-align: center;
  color: #615d61;
  background: #f1f1f1;
  height: 30px;
  font-size: 12px;
  line-height: 30px;
  font-family: "微软雅黑";
  width: 55px;
}

.up {
  display: none;
  position: absolute;
}

.mg_t {
  width: 100%;
  height: 220px;
  /* background: url(../../assets/2019092922564613976.jpg) repeat scroll 0% 0% / 100% 100% */
}

.mg_t_top {
  width: 1200px;
  margin: 0 auto;
}

.logo {
  padding: 35px 0 0 5px;
  float: left;
}

.search {
  float: right;
  padding-top: 45px;
}

.caidanl {
  float: right;
  padding-top: 52px;
}

.caidanl ul li {
  float: left;
  margin-right: 45px;
  line-height: 25px;
}

.caidanl ul li a {
  color: #fff;
  font-size: 13px;
  font-family: "微软雅黑";
}

.dhl {
  width: 1200px;
  margin: 0 auto;
  padding-top: 40px;
}

.dhl ul {
  border-bottom: 1px solid #fff;
  height: 37px;
}

.dhl ul li {
  float: left;
  line-height: 24px;
  width: 150px;
  text-align: center;
  padding-bottom: 9px;
}

.dhl_hover {
  color: #fff;
  font-size: 20px;
  font-family: "微软雅黑";
  font-weight: bold;
  border-bottom: 3px solid #fff;
  padding-bottom: 11px;
}

.dhl_out {
  color: #fff;
  font-size: 18px;
  font-family: "微软雅黑";
  font-weight: bold;
}

.vxx:hover .vx {
  display: block;
}

.vx {
  display: none;
  position: absolute;
}

.vx img {
  width: 120px;
}

.sjj:hover .sj {
  display: block;
}

.sj {
  display: none;
  position: absolute;
}

.sj img {
  width: 120px;
}

.qwe:hover .dhxl {
  display: block;
}

.dhxl {
  position: absolute;
  z-index: 999;
  opacity: 0.9;
  padding-top: 15px;
  display: none;
}

.dhxl table tbody tr td {
  width: 170px;
  border-right: 1px solid #d3d3d3;
}

.dhxl table tbody tr {
  height: 52px;
  border-bottom: 1px solid #c9e0f0;
}

.dhxl table tbody tr td a {
  font-size: 16px;
  font-family: "微软雅黑";
  line-height: 52px;
  display: block;
}

.dhxl table tbody tr td a:hover {
  font-size: 17px;
  font-family: "微软雅黑";
  line-height: 52px;
  display: block;
  color: #f57e3e;
  background: #e8e8e8;
}
</style>